import React from 'react';
import { Container, Form, Button, Card } from 'react-bootstrap';
import '../components/components.css';

const AiStemsSeparator = () => {
  return (
    <Container className="py-4 beats-component-container">
      <h2>AI Stems Separator</h2>
      <p>Upload your audio files to separate them into individual stems (vocals, drums, bass, etc).</p>
      
      <Card className="my-4 p-4 beats-card">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="beats-form-label">Upload Audio File</Form.Label>
            <Form.Control type="file" accept="audio/*" className="beats-form-control" />
            <Form.Text className="text-muted beats-form-text">
              Supported formats: MP3, WAV, FLAC (max 10MB)
            </Form.Text>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label className="beats-form-label">Separation Quality</Form.Label>
            <Form.Select aria-label="Separation quality" className="beats-form-select">
              <option>Standard (Faster)</option>
              <option>High Quality (Slower)</option>
              <option>Ultra (Very Slow)</option>
            </Form.Select>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label className="beats-form-label">Stems to Extract</Form.Label>
            <div>
              <Form.Check inline type="checkbox" id="vocals" label="Vocals" defaultChecked />
              <Form.Check inline type="checkbox" id="drums" label="Drums" defaultChecked />
              <Form.Check inline type="checkbox" id="bass" label="Bass" defaultChecked />
              <Form.Check inline type="checkbox" id="other" label="Other" defaultChecked />
              <Form.Check inline type="checkbox" id="piano" label="Piano" />
              <Form.Check inline type="checkbox" id="guitar" label="Guitar" />
            </div>
          </Form.Group>
          
          <Button variant="primary" type="submit" className="beats-btn-primary">
            Separate Stems
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default AiStemsSeparator; 